import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import CreateAlertModal from './CreateAlertModal';
import { createAlert, editAlert, getAlert } from '../../../redux/actions/advancedSearchAction';
import './advancedSearchAlert.less';

class AdvancedSearchAlert extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false };
  }

  componentDidMount() {
    if (this.props.advancedSearch.filter.alert_id) {
      this.props.getAlert(this.props.advancedSearch.filter.alert_id);
    }
  }

  onClose = () => {
    this.setState({ showModal: false });
  };

  onSave = params => {
    const { save_as_new, ...rest } = params;
    const {
      advancedSearch: { filter },
    } = this.props;

    if (save_as_new) {
      this.props.createAlert(rest, filter);
    } else {
      this.props.editAlert(rest, filter);
    }
    this.onClose();
  };

  clickCreateAlert = () => {
    this.setState({ showModal: true });
  };

  render() {
    const {
      advancedSearch: { showResults, alert },
    } = this.props;
    return (
      <div className="facets-create-alert">
        <Button
          bsSize="small"
          bsStyle="success"
          className="edit-btn"
          onClick={this.clickCreateAlert}
          disabled={!showResults}
        >
          {alert.data && alert.data.id ? (
            <span>Create or Edit Alert</span>
          ) : (
            <span>Create Alert for Current Search</span>
          )}
        </Button>
        <CreateAlertModal
          show={this.state.showModal}
          onSave={this.onSave}
          onClose={this.onClose}
          advancedSearch={this.props.advancedSearch}
        />
      </div>
    );
  }
}

AdvancedSearchAlert.propTypes = {
  createAlert: PropTypes.func.isRequired,
  editAlert: PropTypes.func.isRequired,
  getAlert: PropTypes.func.isRequired,
  advancedSearch: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  advancedSearch: state.toJS().advancedSearch,
});

const mapDispatchToProps = {
  createAlert,
  editAlert,
  getAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchAlert);



// WEBPACK FOOTER //
// ./src/pages/advancedSearch/Alerts/AdvancedSearchAlert.jsx